<template>
  <!-- <Select v-model="company_code"
    :placeholder="$t('account_group')"
    :style="{width: width + (typeof width == 'number' ? 'px' : '')}"
    :size="size"
    class="company_select"
    clearable
    @on-change="handleChange">
    <Option v-for="item in company_list" :key="item.company_code" :value="item.company_code">{{item.name}}</Option>
  </Select> -->
  <Select v-model="company_code"
    :style="{width: width + (typeof width == 'number' ? 'px' : '')}"
    clearable
    :class="size"
    transfer
          :multiple="isMultiple"
    size="small"
    :placeholder="$t('account_group')"
    @on-change="handleChange">
    <Option value="" disabled>{{ $t('account_group') }}</Option>
    <Option v-for="item in company_list" :key="item.company_code" :value="item.company_code">{{item.name}}</Option>
  </Select>
</template>
<script>
import { get_all_company } from "@/api/company";
import {mapActions} from 'vuex'
export default {
  props: {
    width: {
      type: [Number, String],
      default: "auto",
    },
    companyCode: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    isMultiple:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    companyCode(newVal, oldVal) {
      this.company_code = newVal;
    },
  },
  data() {
    return {
      company_list: [],
      company_code: this.isMultiple?[]:"",
    };
  },
  created() {
    let self = this;
    get_all_company().then((res) => {
      self.company_list = res.body;
      // this.$emit("getAddUserData", {data: res.body, type: "add_company_list"});
      this.saveFormData({data: res.body, type: "add_company_list"})
    });
    this.company_code = this.companyCode;
  },
  methods: {
    ...mapActions("formData", ["saveFormData"]),
    handleChange() {
      this.$emit("updateCompanyCode", this.company_code);
    },
  },
};
</script>
<style lang="less" scoped>
.company_select {
  font-size: 14px;
  padding: 6px 7px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  outline: none;
  vertical-align: middle;

  &.small {
    padding-top: 1px;
    padding-bottom: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/company_list.vue